import React from "react";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
const DoctorRoute = ({ component: Component, auth, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      (auth.isAuthenticated === true && ( auth.user.role=="doctor" || auth.user.role=="doctorNurse")) ? (
        <Component {...props} />
      ) : (
        <Redirect to="/login" />
      )
    }
  />
);
DoctorRoute.propTypes = {
  auth: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
  auth: state.authR
});
export default connect(mapStateToProps)(DoctorRoute);
